import { useState, useEffect, useRef } from "react";
import { __ } from "services/Translator";
import api from "services/api";
import moneyFormatter from "services/moneyFormatter";

const normalizeCurrency = (currency) => {
  if (!currency) return "USD";
  const s = String(currency).trim();
  if (s.length === 3 && /^[A-Za-z]{3}$/.test(s)) return s.toUpperCase();
  const map = { "£": "GBP", $: "USD", "€": "EUR" };
  return map[s] || "USD";
};

const parseWinAmount = (entry) => {
  if (entry?.win_amount_float != null) {
    const amount = parseFloat(entry.win_amount_float);
    if (!Number.isNaN(amount)) return amount;
  }
  if (entry?.win_amount != null) {
    const amount = parseFloat(String(entry.win_amount).replace(/,/g, ""));
    if (!Number.isNaN(amount)) return amount;
  }
  return 0;
};

const FALLBACK_WINS = [
  {
    game: { game_name: "Gates Of Olympus" },
    player: { player_nickname: "blurryalan", player_currency: "USD" },
    currency: "$",
    win_amount_float: 6.44,
    win_amount: "6.44",
    tr_id: 28472404,
  },
  {
    game: { game_name: "777 Volt GigaBlox" },
    player: { player_nickname: "Ohmzlaw", player_currency: "USD" },
    currency: "$",
    win_amount_float: 1500,
    win_amount: "1500.00",
    tr_id: 999003,
  },
  {
    game: { game_name: "Sweet Bonanza" },
    player: { player_nickname: "luckyspin", player_currency: "USD" },
    currency: "$",
    win_amount_float: 42.5,
    win_amount: "42.50",
    tr_id: 999004,
  },
  {
    game: { game_name: "Big Bass Splash" },
    player: { player_nickname: "reelking", player_currency: "USD" },
    currency: "$",
    win_amount_float: 128.75,
    win_amount: "128.75",
    tr_id: 999005,
  },
  {
    game: { game_name: "Starburst" },
    player: { player_nickname: "nova77", player_currency: "USD" },
    currency: "$",
    win_amount_float: 24.1,
    win_amount: "24.10",
    tr_id: 999006,
  },
];

const GAME_ICONS = ["🎰", "🎲", "💎", "🃏", "🎯", "⚡", "🔥", "🌟"];
const iconForIndex = (index) => GAME_ICONS[index % GAME_ICONS.length];

export default function LiveWinTicker(props) {
  const [wins, setWins] = useState(FALLBACK_WINS);
  const fetchedRef = useRef(false);

  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;

    api
      .get("/games/recent-bets", { limit: 20 })
      .then((response) => {
        const data = response?.data?.data || [];
        const filtered = data.filter((entry) => parseWinAmount(entry) > 0);
        if (filtered.length > 0) {
          setWins(filtered);
        }
      })
      .catch(() => {});
  }, []);

  const maskName = (name) => {
    if (!name) return "***";
    const s = String(name).trim();
    if (s.length <= 4) return `***${s}`;
    return `***${s.slice(-4)}`;
  };

  const tickerItems = [...wins, ...wins];

  const handleClick = () => {
    if (!props.isAuthenticated && props.setModalSignUpPropsData) {
      props.setModalSignUpPropsData(true);
      setTimeout(() => props.setModalSignUpPropsData(false), 500);
    }
  };

  return (
    <div className="live-win-ticker" aria-label={__("Recent winners")}>
      <div className="ticker-label">
        <span className="ticker-live-dot" aria-hidden="true" />
        <span>{__("Live")}</span>
      </div>
      <div className="ticker-track-wrapper">
        <div className="ticker-track">
          {tickerItems.map((entry, i) => {
            const playerName = maskName(
              entry.player?.player_nickname || entry.player?.player_name || ""
            );
            const gameName = entry.game?.game_name || __("Casino");
            const amount = moneyFormatter.balanceFormat(
              parseWinAmount(entry),
              normalizeCurrency(entry.currency || entry.player?.player_currency)
            );

            return (
              <span
                key={`${entry.tr_id ?? i}-${i}`}
                className="ticker-item"
                role="button"
                tabIndex={0}
                onClick={handleClick}
                onKeyDown={(e) => e.key === "Enter" && handleClick()}
              >
                <span className="ticker-icon" aria-hidden="true">
                  {iconForIndex(i)}
                </span>
                <strong className="ticker-player">{playerName}</strong>
                <span className="ticker-text">{__("won")}</span>
                <span className="ticker-amount">{amount}</span>
                <span className="ticker-game">
                  {__("on")} {gameName}
                </span>
                <span className="ticker-sep" aria-hidden="true">
                  ·
                </span>
              </span>
            );
          })}
        </div>
      </div>
    </div>
  );
}
